import * as React from 'react'

import { IconSearch } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { GlobalSearchInputFieldStyled } from './styles/GlobalSearchInputFieldStyled'
import { GlobalSearchInputWrapperStyled } from './styles/GlobalSearchInputWrapperStyled'

interface IGlobalSearchInputProps {
  query: string
  inputRef: React.RefObject<HTMLInputElement>
  onQueryChange: (value: string) => void
  onSubmit: () => void
}

export const GlobalSearchInput = ({
  query,
  inputRef,
  onQueryChange,
  onSubmit,
}: IGlobalSearchInputProps) => {
  const intl = useProcurifyIntl()

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onQueryChange(e.target.value)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !e.nativeEvent.isComposing) {
      onSubmit()
    }
  }

  return (
    <GlobalSearchInputWrapperStyled>
      <IconSearch size={16} color='textSecondary' />
      <GlobalSearchInputFieldStyled
        ref={inputRef}
        value={query}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={intl.formatMessage(messages.inputPlaceholder)}
        aria-label={intl.formatMessage(messages.inputAriaLabel)}
      />
    </GlobalSearchInputWrapperStyled>
  )
}
